import { Badge, BadgeWithDot } from "@/components/ui/badge"
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip"

import type { Chip } from "../types"

/** The chips in sort-key order, then the guards and flags. A chip with detail opens it in a tooltip. */
export function ChipStrip({
  chips,
  dense,
}: {
  chips: Chip[]
  dense?: boolean
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {chips.map((chip, i) =>
        i === 0 ? (
          <BadgeWithDot
            key={chip.key}
            color={chip.tone}
            type="modern"
            size={dense ? "sm" : "md"}
          >
            {chip.label}
          </BadgeWithDot>
        ) : chip.detail ? (
          <Tooltip key={chip.key} title={chip.detail} placement="top">
            <TooltipTrigger aria-label={`${chip.label}: ${chip.detail}`}>
              <Badge color={chip.tone} size="sm">
                {chip.label}
              </Badge>
            </TooltipTrigger>
          </Tooltip>
        ) : (
          <Badge key={chip.key} color={chip.tone} size="sm">
            {chip.label}
          </Badge>
        ),
      )}
    </div>
  )
}
